import React, { useState, useEffect } from 'react';
import { useClient } from '../../context/ClientContext';

function truncateUrl(url) {
  try {
    const parsed = new URL(url);
    const path = parsed.pathname === '/' ? '' : parsed.pathname;
    return parsed.hostname + path;
  } catch {
    return url;
  }
}

export default function LandingPages({ dateRange }) {
  const { brand, fetcher } = useClient();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetcher.fetchLandingPages(dateRange)
      .then(setData)
      .finally(() => setLoading(false));
  }, [dateRange]);

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/3 mb-4"></div>
        <div className="space-y-2">
          {[...Array(5)].map((_, i) => <div key={i} className="h-8 bg-gray-200 rounded"></div>)}
        </div>
      </div>
    );
  }

  if (!data?.pages?.length) return null;

  const currency = data.currency || '$';

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100 p-6">
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-1"
          style={{ fontFamily: brand.typography?.headerFont }}>
        Landing Page Performance
      </h3>
      <p className="text-xs text-gray-400 mb-4">Top pages by clicks</p>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-2 pr-4 text-xs font-medium text-gray-500 uppercase">URL</th>
              <th className="text-right py-2 px-2 text-xs font-medium text-gray-500 uppercase">Clicks</th>
              <th className="text-right py-2 px-2 text-xs font-medium text-gray-500 uppercase">Conv.</th>
              <th className="text-right py-2 px-2 text-xs font-medium text-gray-500 uppercase">Conv Rate</th>
              <th className="text-right py-2 pl-2 text-xs font-medium text-gray-500 uppercase">CPA</th>
            </tr>
          </thead>
          <tbody>
            {data.pages.map((page, idx) => (
              <tr key={idx} className="border-b border-gray-100 last:border-0">
                <td className="py-2 pr-4 max-w-[200px]">
                  <p className="text-gray-900 truncate text-xs" title={page.url}>
                    {truncateUrl(page.url)}
                  </p>
                </td>
                <td className="text-right py-2 px-2 text-gray-900 font-medium">{page.clicks}</td>
                <td className="text-right py-2 px-2 text-gray-900 font-medium">{page.conversions}</td>
                <td className="text-right py-2 px-2 text-gray-600">{page.convRate.toFixed(1)}%</td>
                <td className="text-right py-2 pl-2 text-gray-600">
                  {page.cpa != null ? `${currency}${page.cpa.toFixed(0)}` : '\u2014'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
